// src/router/index.js (SINTAKS VUE 3)
import { createRouter, createWebHistory } from 'vue-router';
import CodeEntry from '../views/CodeEntry.vue';
import TestDashboard from '../views/TestDashboard.vue';
import TestPreview from '../views/TestPreview.vue';
import TestTaker from '../views/TestTaker.vue'; // Impor langsung untuk kejelasan
import ThankYou from '../views/ThankYou.vue';
import VerificationPage from '../views/VerificationPage.vue';
import AdminProfile from '../views/admin/AdminProfile.vue';
import TestResult from '../views/TestResult.vue'; 


// Impor komponen admin
import AdminWrapper from '../views/admin/AdminWrapper.vue';
import AdminLogin from '../views/admin/AdminLogin.vue';
import AdminDashboard from '../views/admin/AdminDashboard.vue';
import MasterTestManager from '../views/admin/MasterTestManager.vue';
import PackageDetail from '../views/admin/PackageDetail.vue';
import QuestionManager from '../views/admin/QuestionManager.vue';
import ResultsDashboard from '../views/admin/ResultsDashboard.vue';
import ParticipantDetail from '../views/admin/ParticipantDetail.vue';
import InterpretationManager from '../views/admin/InterpretationManager.vue';
import PsychogramManager from '../views/admin/PsychogramManager.vue';
import ScoringMapping from '../views/admin/ScoringMapping.vue';
import PackageEdit from '../views/admin/PackageEdit.vue';
import SubAspectDetail from '../views/admin/SubAspectDetail.vue';
import UserManager from '../views/admin/UserManager.vue';
import EssayCorrection from '../views/admin/EssayCorrection.vue';

import GeraiManager from '../views/admin/GeraiManager.vue';




const routes = [
  {
    path: '/',
    name: 'Home',
    component: CodeEntry,
  },
  {
    path: '/verify',
    name: 'VerificationPage', // 'name' bisa tetap sama, tidak masalah
    component: VerificationPage // <-- Gunakan komponen dengan nama baru
  },

  {
    path: '/dashboard',
    name: 'TestDashboard',
    component: TestDashboard,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('session_token')) next();
      else next({ name: 'Home' });
    },
  },
  {
    path: '/preview/:id',
    name: 'TestPreview',
    component: TestPreview,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('session_token')) next();
      else next({ name: 'Home' });
    }
  },
  {
    // --- HANYA SATU DEFINISI UNTUK RUTE INI ---
    path: '/test/:id',
    name: 'TestTaker',
    component: TestTaker, // Gunakan impor langsung, bukan lazy loading untuk sementara
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('session_token')) next();
      else next({ name: 'Home' });
    }
  },
  
  { // <-- TAMBAHKAN RUTE BARU INI
    path: '/selesai',
    name: 'ThankYou',
    component: ThankYou,
    beforeEnter: (to, from, next) => {
      // Hanya bisa diakses jika ada token (baru selesai tes)
      if (localStorage.getItem('session_token')) {
        next();
      } else {
        next({ name: 'Home' });
      }
    }
  },
  
  {
    path: '/my-result', // Path URL yang akan muncul di browser
    name: 'TestResult', // Nama yang harus sama persis dengan yang Anda panggil
    component: TestResult, // Komponen yang akan dirender
    meta: { requiresAuth: true } // Pastikan halaman ini juga dilindungi
  },


  // --- RUTE ADMIN BARU (Dikelompokkan) ---
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  
  {
    path: '/admin',
    component: AdminWrapper, // Gunakan komponen pembungkus
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('admin_token')) next();
      else next({ name: 'AdminLogin' });
    },
    children: [ // <-- Semua halaman admin menjadi children
      {
        path: 'dashboard', // Path relatif, menjadi /admin/dashboard
        name: 'AdminDashboard',
        component: AdminDashboard,
      },
      {
        path: 'tests', // menjadi /admin/tests
        name: 'MasterTestManager',
        component: MasterTestManager
      },
      {
        path: 'package/:id', // menjadi /admin/package/:id
        name: 'PackageDetail',
        component: PackageDetail,
      },
      {
        path: 'test/:id/questions', // menjadi /admin/test/:id/questions
        name: 'QuestionManager',
        component: QuestionManager,
        props: true,
      },
      {
        path: 'results', // menjadi /admin/results
        name: 'ResultsDashboard',
        component: ResultsDashboard,
      },
      {
        path: 'participant/:id', // menjadi /admin/participant/:id
        name: 'ParticipantDetail',
        component: ParticipantDetail
      }, 
      {
        path: 'participant/:id/session/:sessionId/essay',
        name: 'EssayCorrection',
        component: EssayCorrection
      },
      {
        path: 'gerai', // Akan diakses melalui /admin/gerai
        name: 'GeraiManager',
        component: GeraiManager,
      },
 
      {
        path: 'sub-aspect/:id',
        name: 'SubAspectDetail',
        component: SubAspectDetail
      },
      {
        path: 'interpretations',
        name: 'InterpretationManager',
        component: InterpretationManager
      },
      {
        path: 'package/:id/edit', // menjadi /admin/package/:id/edit
        name: 'PackageEdit',
        component: PackageEdit,
        props: true // Agar 'id' dari URL bisa diakses sebagai prop
      }, 
      {
        path: 'scoring-mapping',
        name: 'ScoringMapping',
        component: ScoringMapping
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: AdminProfile
      },
      {
        path: 'users',
        name: 'UserManager',
        component: UserManager
      },
      {
        path: 'psychogram',
        name: 'PsychogramManager',
        component: PsychogramManager
      }
    ]
  }

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;